 

import { Link } from "react-router-dom";
import calendar from "../../assets/images/svg2/calendar.svg";
import clock from "../../assets/images/svg2/clock.svg";

export default function BreadcrumbSection() {
	return (
		<div className="fugu--breadcrumbs-section">
			<div className="fugu--breadcrumbs-data">
				<h1>NFTs & Japanese Culture: a rising, diverse community</h1>
				<p>
					The Japanese NFT community is in its early days. In this article, we’ll provide an overview of the
					community from the standpoint of cultural exports, namely the mangaverse and gaming.
				</p>
				<div className="fugu--blog-meta">
					<ul>
						<li>
							<Link to={"#"}>
								<img src={calendar} alt="" /> Art & Analusis
							</Link>
						</li>
						<li>
							<Link to={"#"}>
								<img src={clock} alt="" /> July 18, 2022
							</Link>
						</li>
					</ul>
				</div>
			</div>
		</div>
	);
}
